import { render, staticRenderFns } from "./1044.vue?vue&type=template&id=2648e798&scoped=true&lang=html&"
import script from "./1044.vue?vue&type=script&lang=js&"
export * from "./1044.vue?vue&type=script&lang=js&"
import style0 from "./1044.vue?vue&type=style&index=0&id=2648e798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648e798",
  null
  
)

export default component.exports